<template>
  <b-row class="m-0">
    <b-col class="p-0">
      <nav class="navbar navbar-expand-sm">
        <div class="navbar-brand">
          <img
            id="logo"
            class="d-none d-lg-block"
            src="../assets/logo.png"
            alt="Strona główna"
          />
          <img
            id="logo"
            class="d-lg-none"
            src="../assets/logo-small.png"
            alt="Strona główna"
          />
        </div>
        <div class="p-1 small" v-if="isLoggedIn">
            Do końca sesji pozostało: <span :class="getReamingTimeClass">{{ sessionRemainingTimeFormatted }}</span>
        </div>
        <div class="navbar-content">
          <div id="navbar-config">
            <h2 class="sr-only">Ustawienia</h2>
            <div class="wcag " id="assistant-icon" v-if="isMobileDevice">
              <a
                href="#"
                class="assistant"
                :class="contextAssistantActive ? 'warning' : ''"
                v-on:click="toggleAssistant"
                title="Asystent użytkownika"
              >
                <span
                  class="oi oi-question-mark"
                  title="Asystent"
                  aria-hidden="true"
                ></span>
                <span class="sr-only">Asystenet</span>
              </a>
            </div>
            <div class="fontsize">
              <button v-on:click="changeFontSize(1)">
                <span aria-hidden="true">A</span>
                <span class="sr-only">Domyślna czcionka</span>
              </button>

              <button v-on:click="changeFontSize(2)">
                <span aria-hidden="true">A+</span>
                <span class="sr-only">Większa czcionka</span>
              </button>

              <button v-on:click="changeFontSize(3)">
                <span aria-hidden="true">A++</span>
                <span class="sr-only">Największa czcionka</span>
              </button>
            </div>
            <div class="wcag " id="high-contrast-icon">
              <a
                href="#"
                class="contrast"
                v-on:click="changeContrast"
                title="Wersja o wysokim kontraście"
              >
                <icon name="adjust" aria-hidden="true"></icon>
                <span class="sr-only">Wersja o wysokim kontraście</span>
              </a>
            </div>
            <div class="wcag" v-if="isMobileDevice">
              <a
                href="#"
                class="contrast"
                :class="isMobileVersion ? 'warning' : ''"
                v-on:click="toggleMobileVersion"
                title="Wersja mobilna"
              >
                <icon name="mobile" aria-hidden="true"></icon>
                <span class="sr-only">Wersja mobilna</span>
              </a>
            </div>
          </div>
          <div class="navbar-user">
            <div v-if="contextIsAnonymous">
              <b-link
                class="d-none d-md-inline"
                toggle-class="text-decoration-none m-0 p-0"
                @click.prevent="userLogin"
              >
                Zaloguj
              </b-link>
              <b-dropdown
                class="d-md-none"
                title="Użytkownik"
                toggle-class="text-decoration-none m-0 p-0"
                variant="link"
                no-outline
                right
                :no-caret="contextChangeInProgress"
              >
                <template class="d-flex" slot="button-content">
                  <icon name="user" aria-hidden="true"></icon>
                </template>
                <b-dropdown-item @click.prevent="userLogin">
                  <span>
                    Zaloguj
                  </span>
                </b-dropdown-item></b-dropdown
              >
            </div>

            <b-dropdown
              id="context-dropdown"
              title="Użytkownik"
              toggle-class="text-decoration-none m-0 p-0"
              variant="link"
              no-outline
              right
              :no-caret="contextChangeInProgress"
              v-else
            >
              <template class="d-flex" slot="button-content">
                <icon name="user" class="d-md-none" aria-hidden="true"></icon>
                <span class="d-none d-md-inline"> {{ contextEmail }}</span>
                <icon
                  name="circle-notch"
                  aria-hidden="true"
                  class="fas fa-fw fa-lg fa-spin"
                  v-if="contextChangeInProgress"
                ></icon>
              </template>
              <b-dropdown-text class="d-md-none font-weight-bold">
                {{ contextEmail }}
              </b-dropdown-text>
              <b-dropdown-divider class="d-md-none"></b-dropdown-divider>
              <b-dropdown-item
                v-for="context in contextOrganizations"
                :key="context.organizationId"
                @click="
                  if (contextAssistantActive) {
                    showContextChangeUserContextHelp();
                  } else {
                    organizationChanged(context.organizationId);
                  }
                "
              >
                <span
                  class="activeContext "
                  v-if="context.organizationId === contextOrganizationId"
                >
                  {{ context.organizationName }} (aktywny)
                </span>
                <span v-else> {{ context.organizationName }} </span>
              </b-dropdown-item>
              <b-dropdown-divider
                v-if="contextOrganizations && contextOrganizations.length"
              ></b-dropdown-divider>
              <b-dropdown-item
                @click.prevent="
                  if (contextAssistantActive) {
                    showLogoutUserContextHelp();
                  } else {
                    $context.signout();
                  }
                "
                >Wyloguj</b-dropdown-item
              >
            </b-dropdown>
            <div
              id="actual-context-organization-name"
              :title="contextOrganizationName || ''"
              class="position-inherit d-none d-md-inline"
              v-if="!contextIsAnonymous && contextOrganizationName"
            >
              {{ contextOrganizationName }}
            </div>
          </div>
        </div>
      </nav>
    </b-col>
    <confirmation-window ref="confirmationWindow"></confirmation-window>
  </b-row>
</template>

<script>
import { mapGetters } from 'vuex';
import {
  WINDOW_DOWNLOAD_TEMPLATE_HIDE,
  WINDOW_EXPORT_TO_FILE_HIDE,
  WINDOW_ASK_FOR_ARCHIVE_DATA_HIDE,
  CONNECTION_ANALYSIS_TOGGLE,
  SPATIAL_ANALYSIS_HIDE_MODAL,
  RESPONSIVE_VERSION_SET_IF_MOBILE_VERSION,
  TOGGLE_CONTEXT_ASSISTANT
} from '../store/mutations.type';

import {
  CLAUSES_FETCH,
  CANCEL_POLE_ANALYSIS,
  STOP_ROAD_LANE_ANALYSIS,
  COMPOSITIONS_FETCH,
  CANCEL_GET_FEATURE_INFO,
  DEACTIVATE_LAYERS,
  DISPLAY_CONTEXT_ASSISTANT_MESSAGE,
  SESSION_TIMER_START,
  SESSION_TIMER_RESET,
  SESSION_TIMER_STOP
} from '../store/actions.type';

import ConfirmationWindow from './ConfirmationWindow';

export default {
  name: 'AppHeader',
  components: {
    ConfirmationWindow
  },
  computed: {
    ...mapGetters([
      'isMobileDevice',
      'isMobileVersion',
      'contextAssistantActive',
      'sessionRemainingTimeFormatted',
      'getReamingTimeClass'
    ]),
    contextOrganizationName() {
      const fountContext = this.contextOrganizations.find(
        contextOrganization => {
          return (
            contextOrganization.organizationId == this.contextOrganizationId
          );
        }
      );
      return fountContext ? fountContext.organizationName : null;
    },
    isLoggedIn() {
      return !this.$context.state.isAnonymous;
    }
  },
  created() {
        if (this.isLoggedIn) {
      this.$store.dispatch(SESSION_TIMER_START);

      ['click', 'keydown', 'scroll'].forEach(event => {
        window.addEventListener(event, this.resetTimer);
      });
    }
  },
  mounted() {
    const body = document.body;
    const fontSize = localStorage.getItem('fontSize');

    if (localStorage.getItem('contrast') == 'true') {
      if (!body.classList.contains('contrast')) {
        body.classList.add('contrast');
      }
    }

    if (fontSize) {
      switch (fontSize) {
        case '2':
          body.classList.add('bigger-font');
          break;
        case '3':
          body.classList.add('largest-font');
          break;
      }
    }
  },
  methods: {
    changeContrast: function() {
      if (this.contextAssistantActive) {
        this.$store.dispatch(DISPLAY_CONTEXT_ASSISTANT_MESSAGE, {
          message:
            'Naciśnięcie tego przycisku spowoduje przełączenie aplikacji pitmap o wysokim kontraście.'
        });
      } else {
        const body = document.body;

        if (body.classList.contains('contrast')) {
          body.classList.remove('contrast');
          localStorage.setItem('contrast', false);
        } else {
          body.classList.add('contrast');
          localStorage.setItem('contrast', true);
        }
      }
    },
    toggleMobileVersion() {
      if (this.contextAssistantActive) {
        this.$store.dispatch(DISPLAY_CONTEXT_ASSISTANT_MESSAGE, {
          message:
            'Naciśnięcie tego przycisku spowoduje przełączenie aplikacji pitmap między wersją mobilną a komputerową.'
        });
      } else {
        this.$store.commit(
          RESPONSIVE_VERSION_SET_IF_MOBILE_VERSION,
          !this.isMobileVersion
        );
      }
    },
    toggleAssistant() {
      this.$store.commit(TOGGLE_CONTEXT_ASSISTANT);
    },
    changeFontSize: function(item) {
      if (this.contextAssistantActive) {
        this.$store.dispatch(DISPLAY_CONTEXT_ASSISTANT_MESSAGE, {
          message:
            'Naciśnięcie tego przycisku spowoduje zmianę rozmiaru czcionki w aplikacji pitmap.'
        });
      } else {
        const body = document.body;
        localStorage.setItem('fontSize', item);

        switch (item) {
          case 1:
            body.classList.remove('bigger-font');
            body.classList.remove('largest-font');
            break;
          case 2:
            body.classList.remove('largest-font');
            body.classList.add('bigger-font');
            break;
          case 3:
            body.classList.remove('bigger-font');
            body.classList.add('largest-font');
            break;
        }
      }
    },
    organizationChanged(organizationId) {
      const self = this;
      const confirmationWindow = this.$refs.confirmationWindow;
      confirmationWindow.setMessage(
        'Czy na pewno chcesz zmienić kontekst? Spowoduje to zamknięcie niektórych narzędzi oraz ponowne wczytanie kompozycji i warstw.'
      );
      confirmationWindow.setNoAction();
      confirmationWindow.setYesAction(function() {
        self.changeContext({
          organizationId: organizationId,
          then: _ => {
            self.cancelAllLayerTools();
            self.cancelUnauthorizedActions();
            self.updateData();
            window.location.reload();
          },
          catch: _ =>
            self.$notify({
              type: 'error',
              title: 'Uwaga!',
              text: 'Zmiana kontekstu nie powiodła się.',
              duration: 2000
            })
        });
      });

      confirmationWindow.show();
    },
    cancelAllLayerTools() {
      this.$store.dispatch(CANCEL_GET_FEATURE_INFO);
      this.$store.dispatch(DEACTIVATE_LAYERS);
    },
    cancelUnauthorizedActions() {
      if (!this.hasPermission('Templates_download')) {
        this.$store.commit(WINDOW_DOWNLOAD_TEMPLATE_HIDE);
      }

      if (!this.hasPermission('Export_data')) {
        this.$store.commit(WINDOW_EXPORT_TO_FILE_HIDE);
      }

      if (!this.hasPermission('Request_for_archive_data')) {
        this.$store.commit(WINDOW_ASK_FOR_ARCHIVE_DATA_HIDE);
      }

      if (!this.hasPermission('Analysis_pole_usage_costs')) {
        if (
          this.$store.getters.roadLaneAnalysisStarted ||
          this.$store.getters.poleAnalysisReady
        ) {
          this.$store.dispatch(CANCEL_POLE_ANALYSIS);
        }
      }

      if (!this.hasPermission('Analysis_road_line_occupation_costs')) {
        this.$store.dispatch(STOP_ROAD_LANE_ANALYSIS);
      }

      if (!this.hasPermission('Analysis_access_to_broadband')) {
        if (this.$store.getters.connectionAnalysisLaunched) {
          this.$store.commit(CONNECTION_ANALYSIS_TOGGLE);
        }
      }

      if (!this.hasPermission('Spatial_analysis')) {
        this.$store.commit(SPATIAL_ANALYSIS_HIDE_MODAL);
      }
    },
    updateData() {
      this.$store.dispatch(CLAUSES_FETCH);
      this.$store.dispatch(COMPOSITIONS_FETCH, {
        compositionId: this.$store.getters.composition.id,
        userEmail: this.contextEmail
      });
    },
    userLogin() {
      if (this.contextAssistantActive) {
        this.$store.dispatch(DISPLAY_CONTEXT_ASSISTANT_MESSAGE, {
          message: 'Przycisk ten pozwala zalogować się do systemu pitmap.'
        });
      } else {
        this.$context.login();
      }
    },
    showContextChangeUserContextHelp() {
      this.$store.dispatch(DISPLAY_CONTEXT_ASSISTANT_MESSAGE, {
        message:
          'Przycisk ten pozwala zmienić aktualnie wybrany kontekst (organizację).'
      });
    },
    showLogoutUserContextHelp() {
      this.$store.dispatch(DISPLAY_CONTEXT_ASSISTANT_MESSAGE, {
        message: 'Przycisk ten pozwala wylogować się.'
      });
    },
        resetTimer() {
      if (this.isLoggedIn) {
        this.$store.dispatch(SESSION_TIMER_RESET);
      }
    }
  },
    beforeDestroy() {
    ['click', 'keydown', 'scroll'].forEach(event => {
      window.removeEventListener(event, this.resetTimer);
    });
    this.$store.dispatch(SESSION_TIMER_STOP);
  },
  watch: {
    isLoggedIn(loggedIn) {
      if (loggedIn) {
        this.$store.dispatch(SESSION_TIMER_START);
      } else {
        this.$store.dispatch(SESSION_TIMER_STOP);
      }
    }
  }
};
</script>

<style lang="scss" src="Style/header.scss">
@import 'Style/header.scss';
</style>

<style>
.navbarDropdown {
  padding-top: 0.25em;
}

.activeContext {
  color: #2b4c98;
  font-weight: bold;
}
.dropdown-menu {
  max-height: 300px;
  overflow: auto;
  max-width: 90vw;
  width: max-content;
}
.b-dropdown-text {
  font-weight: bold !important;
}
.b-dropdown-text,
.dropdown-item,
.dropdown-item > span {
  white-space: normal;
  overflow-wrap: break-word;
}
.btn-group {
  display: flex !important;
}
#high-contrast-icon {
  margin-right: 10px;
}
#assistant-icon {
  margin-right: 10px;
  margin-bottom: 3px;
}
.warning {
  color: #ffc107 !important;
}
.text-align-center {
  text-align: center;
}
#context-dropdown {
  width: min-content;
}
.navbar-user {
  display: flex;
  flex-direction: column;
  align-items: end;
  max-width: min-content;
}
#actual-context-organization-name {
  display: inline-block;
  max-width: 300px; /* Set your desired maximum width */
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
